export enum NotificationDataType {
  // org-be
  SUPERVISOR_EMPLOYEE_CREATE = "SUPERVISOR_EMPLOYEE_CREATE",
  SUPERVISOR_EMPLOYEE_INACTIVATE = "SUPERVISOR_EMPLOYEE_INACTIVATE",
  SUPERVISOR_EMPLOYEE_DELETE = "SUPERVISOR_EMPLOYEE_DELETE",

  // booking-be
  BOOKING_START_REMINDER = "BOOKING_START_REMINDER",
  BOOKING_END_REMINDER = "BOOKING_END_REMINDER",
  BOOKING_INACTIVATION_ALERT = "BOOKING_INACTIVATION_ALERT",
  BOOKING_CHECKIN_REMINDER = "BOOKING_CHECKIN_REMINDER",

  TEAM_BOOKING = "TEAM_BOOKING",
  NOT_BOOKED_REMINDER = "NOT_BOOKED_REMINDER",

  BOOKING_APPROVAL_REQUEST = "BOOKING_APPROVAL_REQUEST",
  BOOKING_APPROVAL_APPROVED = "BOOKING_APPROVAL_APPROVED",
  BOOKING_APPROVAL_REJECTED = "BOOKING_APPROVAL_REJECTED",
  BOOKING_APPROVAL_ADMIN = "BOOKING_APPROVAL_ADMIN",

  SERVICE_QUANTITY_CHANGE = "SERVICE_QUANTITY_CHANGE",
  SERVICE_STATUS_INFO = "SERVICE_STATUS_INFO",

  COLLEAGUE_INQUIRY = "COLLEAGUE_INQUIRY",

  FLEET_BOOKING_START_REMINDER = "FLEET_BOOKING_START_REMINDER",
  FLEET_BOOKING_END_REMINDER = "FLEET_BOOKING_END_REMINDER",

  FLEET_ADMIN_BOOKING_START_REMINDER = "FLEET_ADMIN_BOOKING_START_REMINDER",
  FLEET_ADMIN_BOOKING_END_REMINDER = "FLEET_ADMIN_BOOKING_END_REMINDER",
  FLEET_ADMIN_CHECKIN_REMINDER = "FLEET_ADMIN_CHECKIN_REMINDER",

  FLEET_BOOKING_CREATED_FOR_ME = "FLEET_BOOKING_CREATED_FOR_ME",
  FLEET_BOOKING_TIME_CHANGED = "FLEET_BOOKING_TIME_CHANGED"
}

export type NotificationData = {
  id: number;
  name: string;
  en: string;
  de: string;
};

export type NotificationSettingOptions = {
  name: string;
  en: string;
  de: string;
};

export type NotificationLocationHierarchy = {
  locations: Array<{
    inventoryId: number;
    /** Primary line (building / site). */
    name: string;
    /** Secondary line (e.g. city); omitted when redundant with name. */
    subtitle?: string;
  }>;
  floors: Array<{
    inventoryId: number;
    name: string;
    locationInventoryId: number;
  }>;
  /** Conference zones only (`CONFERENCEZONE`); property name `rooms` matches API / UX label. */
  rooms: Array<{
    inventoryId: number;
    name: string;
    floorInventoryId: number;
    locationInventoryId: number;
  }>;
};

export type RemoteNotificationSetting = {
  enabledNotifications: string[];
  notificationOptions: NotificationData[];
  bookingStartReminderMinutes?: number;
  bookingCheckInReminderMinutes?: number;
  fleetBookingStartReminderMinutes?: number;
  fleetAdminBookingStartReminderMinutes?: number;
  fleetBookingEndReminderMinutes?: number;
  fleetAdminBookingEndReminderMinutes?: number;
  /** Null or empty from BE means "all" bookable inventories for approval-admin scope. */
  approvalNotificationBookingInventoryIds?: number[] | null;
  locationHierarchy?: NotificationLocationHierarchy;
};
